import React, {useEffect, useState} from 'react'
import {Col, Form, Label, Row} from 'react-bootstrap'
import Switch from "react-switch";

import CheckpointSelector from '../../checkpoint/CheckpointSelector'
import FormButtons from '../../component/Form/FormButtons';
import {ReadpointCheckpointTargetService} from '../../services/ReadpointCheckpointTargetService';
import Notify from '../../services/Notify';
import Loading from '../../component/Loading/Loading';
import BizLocationSelector from '../../component/BizLocation/BizLocationSelector';

export function ReadpointCheckpointTargetForm({history, readpointTarget}) {

  const [isLoading, setIsLoading] = useState(false)
  const [readpointCheckpointTarget, setReadpointCheckpointTarget] = useState({version: null, canDoAutomaticTransaction: false})

  const getReadpointCheckpointTarget = async (id) => {
    try {
      const data = await new ReadpointCheckpointTargetService().findOneByReadPointId(id);
      setReadpointCheckpointTarget(data);
    } catch (error) {
      let status = error.response && error.response.status;
      if (status === 404) {
        Notify.warning("Ponto de controle não configurado");
        return;
      }
      Notify.error("Ponto de controle não encontrado", error);
    }
  }

  const submit = async (event) => {
    event.preventDefault()
    try {
      setIsLoading(true)
      readpointCheckpointTarget.bizLocation = readpointCheckpointTarget.bizLocation ? {id: readpointCheckpointTarget.bizLocation.id} : null;
      readpointCheckpointTarget.checkpoint = readpointCheckpointTarget.checkpoint ? {id: readpointCheckpointTarget.checkpoint.id} : null;
      if (readpointCheckpointTarget && readpointCheckpointTarget.readpoint.id === readpointTarget.id) {
        await new ReadpointCheckpointTargetService().editReadpointCheckpointTargetById(readpointCheckpointTarget.id, readpointCheckpointTarget)
        Notify.success('Portal automático editado com sucesso!')
      } else {
        await new ReadpointCheckpointTargetService().createReadpointCheckpointTarget(readpointCheckpointTarget);
        Notify.success('Portal automático criado com sucesso!');
      }

      history.goBack()
    } catch (error) {
      setIsLoading(false)
      if (!readpointCheckpointTarget && error.response && /Duplicate key/.test(error.response.data.message)) {
        return Notify.warning('Este portal automático já foi criado')
      }
      Notify.error('Houve um erro interno, tente novamente mais tarde.', error)
    }
  }

  useEffect(() => {
    if (readpointTarget.id) {
      getReadpointCheckpointTarget(readpointTarget.id)
    }
  }, [])

  return (
    <Form onSubmit={e => submit(e)}>
      <Row className="w-100">
        <Col md={12} className="w-100">
          <Label>Ponto de leitura</Label>
        </Col>
        <Col md={10}>
          <h4>{readpointTarget.friendlyName}</h4>
        </Col>
        <Col md={2}>
          <Row className="w-100">
            <Col md={12} className="w-100">
              <Label>Leitura automática</Label>
            </Col>
            <Col md={12} className="mt-2">
              <Switch
                width={70}
                checked={readpointCheckpointTarget.canDoAutomaticTransaction}
                onChange={() => setReadpointCheckpointTarget({
                  ...readpointCheckpointTarget,
                  canDoAutomaticTransaction: !readpointCheckpointTarget.canDoAutomaticTransaction
                })}
                onColor={'#00cfc3'}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="w-100">
        <Col md={12}>
          {readpointCheckpointTarget.canDoAutomaticTransaction && <CheckpointSelector required filter={`?type=DEFAULT&_readpointId=${readpointTarget.id}`}
                                                                                      defaultValue={readpointCheckpointTarget.checkpoint}
                                                                                      onChange={checkpoint => setReadpointCheckpointTarget({
                                                                                        ...readpointCheckpointTarget,
                                                                                        checkpoint
                                                                                      })}/>}
        </Col>
      </Row>
      <Row className="w-100">
        <Col md={12}>
          <BizLocationSelector defaultValue={readpointCheckpointTarget.bizLocation}
                               onChange={bizLocation => setReadpointCheckpointTarget({
                                 ...readpointCheckpointTarget,
                                 bizLocation
                               })}
          />
        </Col>
      </Row>
      <Row className="w-100 justify-content-start mt-5">
        <Col md={12}>
          {isLoading ? <Loading/> : <FormButtons history={history}/>}
        </Col>
      </Row>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/pages/ReadpointCheckpointTargetPage/ReadpointCheckpointTargetForm.js